import * as React from "react";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { USE_SELECTED_INDEX } from "../../../hooks/useSelectedElement";
import { useSetRecoilState } from "recoil";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import { clickHandler } from "../../../lib/clickHandler";
import { isEqual } from "lodash";
import {
  IXHeaderProps,
  XHeaderProps,
} from "../../../utils/interfaces/common/XHeader.interfaces";

import { useXCommon } from "../../../hooks/useXCommon";
import { useMount } from "react-use";
import XHeaderCore from "./core";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XHeader: React.FC<XHeaderProps> = React.memo(
  ({ initData = { all: {} } }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    const { xCommon, setXCommon } = useXCommon("HEADER");

    useMount(() => {
      if (!xCommon) {
        setXCommon({
          name: "XHeader",
          childOf: null,
          elementsIndexes: [],
          hasChildren: true,
          hierachy: "XHeader",
          index: "HEADER",
          value: initData,
        });
      }
    });

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE
    const setSelectedElement = useSetRecoilState(USE_SELECTED_INDEX);

    // WE GET ALL DEVICES PROPS AS VALUE
    const devProps = {
      id: "HEADER",
      onClick: (e: any) => clickHandler(e, setSelectedElement, "HEADER"),
    };

    if (!xCommon) return null;

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xCommon;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXHeaderProps>(
      value,
      breakpoint
    );

    return (
      <XHeaderCore
        index="HEADER"
        props={valueAtBreakPoint}
        devProps={devProps}
      />
    );
  },
  compareProps
);

export default XHeader;
